import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Tab {
  id: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class OwnerPortalTabsService {
  private activeTabSubject = new BehaviorSubject<string>('overview');
  activeTab$ = this.activeTabSubject.asObservable();

  getTabs(): Tab[] {
    return [
      { id: 'overview', title: 'ownerPortalDashboard.tabs.overview' },
      { id: 'profile', title: 'ownerPortalDashboard.tabs.profile' },
      { id: 'wallet', title: 'ownerPortalDashboard.tabs.wallet' },
      { id: 'marketing', title: 'ownerPortalDashboard.tabs.marketing' },
      { id: 'add-unit', title: 'ownerPortalDashboard.tabs.add-unit' },
    ];
  }

  getActiveTab(): string {
    return this.activeTabSubject.value;
  }

  setActiveTab(tabId: string): void {
    this.activeTabSubject.next(tabId);
  }
}
